"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Close;

var _Close = require("@adobe/react-spectrum-workflow/dist/Close");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Close(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Close.A4uClose, null));
}